import { render, staticRenderFns } from "./FormConsultaCPF.vue?vue&type=template&id=40f82d9b"
import script from "./FormConsultaCPF.vue?vue&type=script&lang=ts"
export * from "./FormConsultaCPF.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports